import React, { useContext } from 'react';
import styles from './InvoiceS3.styles.js';
import AppButton from 'Components/common/Forms/AppButton/AppButton.jsx';
import { Input, Button, Select, Radio } from 'antd';
import { AppContext } from 'App.context.js';
import useInvoiceS3ConfigHook from './InvoiceS3.hook.js';
import Loading from 'Components/common/Loader/Loading.jsx';
import { show2FAModal } from 'Components/common/TwoFactorModal/TwoFactorModal';

export default function InvoiceS3() {
  const { state, actions } = useInvoiceS3ConfigHook();

  const {
    appActions: { translate },
  } = useContext(AppContext);

  return (
    <div>
      <div style={{ marginTop: '16px' }}>
        <b style={styles.confTitle}>{translate('policeReport.s3ConfigurationTitle')}</b>
      </div>

      <div style={styles.credentialsContainer}>
        <div style={styles.inputContainer}>
          <b style={styles.header}>{translate('policeReport.ftpHost')}</b>
          <Input
            bordered={false}
            value={'invoicesftp.civitfun.com'}
            onChange={e => actions.setField('ftpHost', e.target.value)}
            disabled={true}
            style={{ backgroundColor: '#f5f5f5' }}
          />
        </div>
        <div style={styles.port}>
          <b style={styles.header}>{translate('policeReport.ftpPort')}</b>
          <Input
            bordered={false}
            value={'22'}
            disabled={true}
            style={{ backgroundColor: '#f5f5f5' }}
          />
        </div>

        <div style={styles.s3User}>
          <b style={styles.header}>{translate('hbxProducts.s3UserName')}</b>
          <Input
            bordered={false}
            value={state.s3UserName || ''}
            disabled={true}
            style={{ backgroundColor: '#f5f5f5' }}
          />
        </div>
      </div>
      <div style={styles.credentialsContainer}>
        <div style={styles.inputContainer}>
          <b style={styles.header}>{translate('policeReport.ftpFilePrefix')}</b>
          <Input
            bordered={false}
            value={state.filePrefix || ''}
            onChange={e => actions.setField('filePrefix', e.target.value)}
            disabled={state.isLoading}
            style={{ backgroundColor: '#f5f5f5' }}
          />
        </div>

        <div style={styles.inputContainer}>
          <b style={styles.header}>{translate('policeReport.fileFormat')}</b>
          <Select
            defaultValue="YYYY-MM-DD"
            bordered={false}
            value={state.fileFormat || 'YYYY-MM-DD'}
            style={{ backgroundColor: '#f5f5f5', width: '100%' }}
            onChange={value => actions.setField('fileFormat', value)}
            options={[
              { value: 'YYYY-MM-DD', label: 'YYYY-MM-DD' },
              { value: 'YYYYMMDD', label: 'YYYYMMDD' },
              { value: 'DD-MM-YYYY', label: 'DD-MM-YYYY' },
              { value: 'DDMMYYYY', label: 'DDMMYYYY' },
            ]}
            disabled={state.isLoading}
          />
        </div>

        <div style={styles.inputContainer}>
          <b style={styles.header}>{translate('policeReport.ftpFileSufix')}</b>
          <Input
            bordered={false}
            value={state.fileSufix || ''}
            onChange={e => actions.setField('fileSufix', e.target.value)}
            disabled={state.isLoading}
            style={{ backgroundColor: '#f5f5f5' }}
          />
        </div>

        <div style={styles.inputContainer}>
          <b style={styles.header}>{translate('policeReport.extension')}</b>
          <Select
            bordered={false}
            value={state.extension || '.xml'}
            style={{ backgroundColor: '#f5f5f5', width: '100%' }}
            onChange={value => actions.setField('extension', value)}
            options={[
              { value: '.xml', label: '.xml' },
              { value: '.XML', label: '.XML' },
            ]}
            disabled={state.isLoading}
          />
        </div>
      </div>
      <div style={styles.credentialsContainer}>
        <div style={styles.inputContainer}>
          <b style={styles.header}>{translate('policeReport.completeFileName')}</b>
          <Input
            bordered={false}
            value={
              (state.filePrefix ? state.filePrefix : '') +
              state.fileFormat +
              (state.fileSufix ? state.fileSufix : '') +
              state.extension
            }
            disabled={true}
            style={{ backgroundColor: '#f5f5f5' }}
          />
        </div>
        <div style={styles.inputContainer}>
          <b style={styles.header}>{translate('hbxProducts.sourcePMS')}</b>
          <Select
            bordered={false}
            value={state.sourcePms || 'Opera'}
            style={{ backgroundColor: '#f5f5f5', width: '100%' }}
            onChange={value => {
              actions.setField('sourcePms', value);
              actions.setField('authMethod', value === 'Opera' ? 'password' : 'ssh');
            }}
            options={[{ value: 'Opera', label: 'Opera V5' }]}
            disabled={state.isLoading}
          />
        </div>
      </div>

      <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start' }}>
        <div style={{ flex: 1 }}>
          <div style={styles.inputContainer}>
            <b style={{ ...styles.header, marginBottom: 5, display: 'block' }}>
              {translate('hbxProducts.authenticationMethod')}
            </b>
            {state.sourcePms !== 'Opera' ? (
              <Radio.Group
                value={state.authMethod}
                onChange={e => {
                  actions.setField('authMethod', e.target.value);
                }}
                disabled={state.isLoading}
              >
                <Radio
                  value="ssh"
                  style={{
                    opacity: state.authMethod === 'ssh' ? 1 : 0.5,
                    color: state.authMethod === 'ssh' ? 'inherit' : '#707070ff',
                  }}
                >
                  {translate('hbxProducts.publicSSHKey')}
                </Radio>
                <Radio
                  value="password"
                  style={{
                    opacity: state.authMethod === 'password' ? 1 : 0.5,
                    color: state.authMethod === 'password' ? 'inherit' : '#707070ff',
                  }}
                >
                  {translate('policeReport.ftpPass')}
                </Radio>
              </Radio.Group>
            ) : (
              <div>{translate('policeReport.ftpPass')}</div>
            )}
          </div>

          {state.authMethod === 'ssh' && (
            <div style={styles.inputContainer}>
              <Input.TextArea
                bordered={false}
                value={state.sshKey}
                onChange={e => actions.setField('sshKey', e.target.value)}
                disabled={state.isLoading}
                rows={4}
                style={{
                  backgroundColor: '#f5f5f5',
                }}
                placeholder={translate('hbxProducts.sshKeyPlaceholder')}
              />
            </div>
          )}

          {state.authMethod === 'password' && (
            <div style={styles.inputContainer}>
              <Input.Password
                bordered={false}
                value={state.s3Pass || ''}
                onChange={e => actions.setField('s3Pass', e.target.value)}
                disabled={state.isLoading}
                style={{
                  backgroundColor: '#f5f5f5',
                  backgroundColor: state.invalidPass == true ? '#ffe6e6' : '#f5f5f5',
                }}
                visibilityToggle={actions.isAdmin()}
              />
              <div style={styles.buttonPassword}>
                <AppButton
                  text={translate('hbxProducts.generatePassword')}
                  secondary
                  action={() => {
                    const s3Pass = actions.generatePassword();
                    actions.setField('s3Pass', s3Pass);
                  }}
                  disabled={state.isLoading}
                />
              </div>
            </div>
          )}
        </div>

        {/* IPs */}
        <div style={{ flex: 1 }}>
          <b style={{ ...styles.header, marginBottom: 5, display: 'block' }}>
            {translate('hbxProducts.ipAddress')}
          </b>
          {state.ips.map((ip, index) => (
            <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: 5 }}>
              <Input
                bordered={false}
                value={state.ips[index]}
                onChange={e => {
                  const newIps = [...state.ips];
                  newIps[index] = e.target.value.replace(/[^0-9.]/g, '');
                  actions.setField('ips', newIps);
                }}
                disabled={state.isLoading}
                style={{
                  backgroundColor: state.invalidIps?.includes(state.ips[index])
                    ? '#ffe6e6'
                    : '#f5f5f5',
                  flex: 1,
                  height: '38px',
                  boxSizing: 'border-box',
                  marginRight: 5,
                  padding: '0 8px',
                }}
                placeholder={translate('hbxProducts.putIp')}
              />

              {state.ips.length > 1 && (
                <Button
                  type="button"
                  onClick={() => {
                    const newIps = [...state.ips];
                    const removedIp = newIps[index];

                    newIps.splice(index, 1);

                    actions.setField('removedIps', [...(state.removedIps || []), removedIp]);

                    actions.setField('ips', newIps);
                  }}
                  style={{
                    background: 'red',
                    color: 'white',
                    border: 'none',
                    padding: '2px 6px',
                    cursor: 'pointer',
                    borderRadius: '3px',
                  }}
                ></Button>
              )}
            </div>
          ))}
          <Button
            type="button"
            onClick={() => actions.setField('ips', [...state.ips, ''])}
            style={{ marginTop: 5 }}
          >
            {translate('hbxProducts.addAnotherIp')}
          </Button>
        </div>
      </div>

      <div style={styles.buttonContainer}>
        {state.isLoading && <Loading size={'small'} />}
        <AppButton
          text={translate('policeReport.checkConnection')}
          secondary
          action={() => actions.onCheckConnection()}
          disabled={state.isLoading}
        />

        <AppButton
          text={translate('policeReport.save')}
          action={async () => {
            const twoFAResult = await show2FAModal();

            if (twoFAResult === true) {
              actions.onSaveS3Config();
            }
          }}
          disabled={state.isLoading}
        />
      </div>
    </div>
  );
}
